<mat-form-field>
  <mat-label>Mes</mat-label>
  <mat-select [(value)]="selectedMonth" (selectionChange)="selectionChange()">
    <mat-option *ngFor="let month of months" [value]="month.value">{{
      month.displayName
    }}</mat-option>
  </mat-select>
</mat-form-field>
